import { render, staticRenderFns } from "./DashboardUsecases.vue?vue&type=template&id=0f3fcdc6&scoped=true"
import script from "./DashboardUsecases.vue?vue&type=script&lang=js"
export * from "./DashboardUsecases.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f3fcdc6",
  null
  
)

export default component.exports